import React from 'react';
import Button from 'flow/components/ui-components/Button';
import useAppContext from 'flow/hooks/useAppContext';

interface Props {
    onAcceptAll: () => void;
    onRejectAll: () => void;
    onCustomise: () => void;
}

const TrackingConsentOverview = ({
    onAcceptAll,
    onRejectAll,
    onCustomise,
}: Props) => {
    const { i18next } = useAppContext();

    return (
        <div className="flex h-full flex-col px-6 pb-6">
            <div className="flex flex-col gap-3">
                <p className="font-medium text-gray-800">
                    {i18next.t('settings.general.tracking.intro')}
                </p>
                <p className="text-sm text-gray-500">
                    {i18next.t('settings.general.tracking.details')}
                </p>
            </div>

            <div className="mt-auto flex flex-col gap-3">
                <Button
                    color="ghost"
                    className="w-full py-3"
                    onClick={onAcceptAll}
                >
                    {i18next.t('settings.general.tracking.accept.all')}
                </Button>
                <Button
                    color="ghost"
                    className="w-full py-3"
                    onClick={onRejectAll}
                >
                    {i18next.t('settings.general.tracking.reject.all')}
                </Button>
                <Button
                    color="ghost"
                    className="w-full py-3"
                    onClick={onCustomise}
                >
                    {i18next.t('settings.general.tracking.customise')}
                </Button>
            </div>
        </div>
    );
};

export default TrackingConsentOverview;
